import NetworkLogic from "../../Shared/NetworkLogic";


class WechatNoticeData {

    wechatData = null;

    getWechatData():Promise<any>{
        return new Promise(resolve => {
            NetworkLogic.wechatNotice({},function (rec) {
                resolve(rec)
            }.bind(this),function () {
                resolve(null)
            })
        })
    }

}
export default new WechatNoticeData
